const PlantVarietyInstructions = () => (
    <div className="instructions">
            <h2>Plant Variety Instructions</h2>
            <h4>Add a new variety:</h4>
            <ul>
                <li>Select a crop from your current crops. For example, select tomato if you are about to enter a new tomato variety.</li>
            <li>Press the add variety button to create a new variety for that crop and start inserting the specifics.</li>
                <li>Press the save variety button to load the new variety information.</li>
            </ul>

            <h4>Update an existing variety:</h4>
            <ul>
                <li>select a crop from your current crops then click on a variety to load the specifics.</li>
                <li>Make changes to the field values.</li>
                <li>Press the update variety button to update and save the new variety information.</li>
            </ul>

            <h4>Delete a variety:</h4>
            <ul>
                <li>Click on a variety located on the right-hand side to load the variety information into the form.</li>
                <li>Press the delete variety button to permanently remove the variety information.</li>
            </ul>
        </div>
);
export default PlantVarietyInstructions;
